import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserStoreEffects } from './effects';
import { userReducer } from './reducer';
import { UserFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, userReducer), EffectsModule.forFeature([UserStoreEffects])],
  exports: [],
  providers: [UserFacade],
  declarations: [],
})
export class UserStateModule {}
